import type { MentionableItem, MentionableShortcut } from '../types'
import type { SkillCandidateListing, SkillCompareSide } from './skill-compare-api'

/** Blind label: A is the left side, so the dev never reads old/new off the UI. */
export function sideLabel(leftIsNew: boolean, side: SkillCompareSide): 'A' | 'B' {
  return side === (leftIsNew ? 'new' : 'old') ? 'A' : 'B'
}

/** The catalog skill a submission invokes by mention, if any. */
export function mentionedSkillId(mentions: ReadonlyArray<MentionableItem>): string | null {
  const skillMention = mentions.find(
    (mention): mention is MentionableShortcut => mention.type === 'shortcut' && !!mention.skillId,
  )
  return skillMention?.skillId ?? null
}

/** The active candidates of the mentioned skill: one runs; two (prompt and setup) is ambiguous. */
export function candidatesForMentions(
  mentions: ReadonlyArray<MentionableItem>,
  candidates: ReadonlyArray<SkillCandidateListing>,
): Array<SkillCandidateListing> {
  const skillId = mentionedSkillId(mentions)
  return skillId ? candidates.filter((candidate) => candidate.skillExternalId === skillId) : []
}

/** A comparison runs one candidate, so a skill with an active prompt and an active setup needs one deactivated first. */
export function ambiguousCandidates(candidates: ReadonlyArray<SkillCandidateListing>): string {
  return `${candidates[0].skillSlug} has an active ${candidates.map((c) => c.field).join(' and ')} candidate. Deactivate one on skills.hlai.dev.`
}
